<template>
  <span v-if="employment.hours">
    {{ hoursDisplay }}
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  employment: {
    type: Object,
    required: true,
    default() {
      return {}
    },
  },
})

const hoursDisplay = computed(() => {
  const hours = props.employment?.hours
  if (hours?.exact) {
    return `${hours.exact} uur`
  } else if (hours?.min && hours?.max) {
    if (hours.min === hours.max) {
      return `${hours.min} uur`
    }
    return `${hours.min} - ${hours.max} uur`
  } else if (hours?.min) {
    return `${hours.min} uur`
  } else if (hours?.max) {
    return `${hours.max} uur`
  }
  return ''
})
</script>
